import { render, staticRenderFns } from "./CardSortDialog.vue?vue&type=template&id=380950ca&scoped=true&"
import script from "./CardSortDialog.vue?vue&type=script&lang=js&"
export * from "./CardSortDialog.vue?vue&type=script&lang=js&"
import style0 from "./CardSortDialog.vue?vue&type=style&index=0&id=380950ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380950ca",
  null
  
)

export default component.exports